export const ROLE_OPTIONS = [
  { label: "Supervisor", value: "supervisor" },
  { label: "Fleet Operator", value: "fleet_operator" },
  { label: "Renter", value: "renter" },
  { label: "Admin", value: "admin" },
]
